import ButtonWrap from './styles';

import Desktop from '../../../Desktop';
import Mobile from '../../../Mobile';

/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';

/**
 * NaavButton
 * 
 * @param {number} id 
 * @param {object} onHover
 * @param {function} onClick
 * @param {*} Icon
 * @param {boolean} active
 * @param {*} children
 * 
 * @returns 
 */
const NavButton = ({ id, onHover, onClick, Icon, active, children }) => {
  const [hover, setHover] = useState(false);

  return (
    <ButtonWrap active={active}>
      <Mobile>
        <button
          className="mobile"
          onClick={(e) => {
            onClick(e);
          }}
        >
          {Icon}
        </button>
      </Mobile>
      <Desktop>
        <button
          className="desktop"
          onMouseEnter={(e) => {
            if (active) {
              if (active && onHover) {
                setHover(true);
              }
            }
          }}
          onMouseLeave={(e) => {
            setHover(false);
          }}
          onClick={(e) => {
            if (hover) {
              onHover.onClick(e);
            } else {
              onClick(e);
            }
          }}
          id={id}
        >
          {hover ? onHover.content : children}
        </button>
      </Desktop>
    </ButtonWrap>
  );
};

NavButton.properties = {
  id: 'CPN-MP-NAV_BUTTON',
  ignore: true,
  alias: 'Botão de navegação',
  description:
    'Botão de navegação e alternância entre abas do painel lateral de menu',
};

export default NavButton;
